var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_filter",
    "data-name": "icon - filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M10.5,20.3a.3.3,0,0,1-.3-.3V6.688l-3.8,3.532a.3.3,0,1,1-.408-.439l4.309-4A.3.3,0,0,1,10.8,6V20a.3.3,0,0,1-.3.3m5.2-.08,4.31-4a.3.3,0,1,0-.409-.439l-3.8,3.531V6a.3.3,0,1,0-.6,0V20a.3.3,0,0,0,.18.275.293.293,0,0,0,.12.025.3.3,0,0,0,.2-.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon-sort.45e26da9a4358dd59aaa4635f55a1bc5.svg";
export { ForwardRef as ReactComponent };